// @flow
import type {UserAgentDeviceFlags} from '../../server/utils/systemData';

/**
 * Responsive breakpoint constants
 * c.f. @homeaway/baseline/release/variables/_variables.less
 */
export const BREAKPOINTS = {
    XS_MIN: 480,
    SM_MIN: 768,
    MD_MIN: 992,
    LG_MIN: 1200,
    XL_MIN: 1500 // HA_SERP_THREE_PACK
};

export type Breakpoint = $Keys<typeof BREAKPOINTS>;

/**
 * Given an object of device flags, return an appropriate Breakpoint.
 * Used for server renders.
 * @param {UserAgentDeviceFlags} flags
 */
export const breakpointFromDeviceFlags = (
    flags: UserAgentDeviceFlags
): Breakpoint => {
    if (flags.isDesktop) {
        return 'MD_MIN';
    } else if (flags.isTablet) {
        return 'SM_MIN';
    }

    return 'XS_MIN';
};

/**
 * Test a breakpoint against a media query.
 * Only supports minWidth
 * @param {Breakpoint} current
 * @param {Breakpoint} minWidth
 */
export const media = (
    current: Breakpoint,
    {minWidth}: {minWidth: Breakpoint}
): boolean => {
    return BREAKPOINTS[current] >= BREAKPOINTS[minWidth];
};

export default BREAKPOINTS;
